import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagComponent } from './tag/tag.component';
import { SelectComponent } from './select/select.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActionButtonComponent } from './action-button/action-button.component';
import { InputComponent } from './input/input.component';
import { DateTimeComponent } from './date-time/date-time.component';
import { UserPendingComponent } from './user-pending/user-pending.component';
import { GalleryComponent } from './gallery/gallery.component';
import { TextComponent } from './text/text.component';
import { TextareaComponent } from './textarea/textarea.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { TabPanesComponent } from './tab-panes/tab-panes.component';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [
    TagComponent,
    SelectComponent,
    ActionButtonComponent,
    InputComponent,
    DateTimeComponent,
    UserPendingComponent,
    GalleryComponent,
    TextComponent,
    TextareaComponent,
    DatePickerComponent,
    TabPanesComponent
  ],
  imports: [
    CommonModule,
    IonicModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    TranslocoModule
  ],
  exports: [
    TagComponent,
    SelectComponent,
    ActionButtonComponent,
    InputComponent,
    DateTimeComponent,
    UserPendingComponent,
    GalleryComponent,
    TextComponent,
    TextareaComponent,
    DatePickerComponent,
    TabPanesComponent
  ]
})
export class GeneralModule {}
